import {Shipment} from "../model/Shipment";
import {ShipmentEvent} from "../model/ShipmentEvent";

export const incotermIncludes = (options: string[], shipment: Shipment) => {
    return options.includes(shipment.incoterms?.name);
}

export const findShipmentEvent = (source: ShipmentEvent[], event: string) => {
    return source ? source.find((shipmentEvent) => shipmentEvent.shortName === event) ?? null : null;
}